@if (!prefix && !suffix && !stepCounter && !colorPicker) {
  <div class="classic-input" [formGroup]="form" [class.withicon]="icon">
    <label
      [ngClass]="{ 'd-none': Label == '' }"
      class="form-label h4-bold d-flex align-items-center justify-content-between"
      ><div class="d-flex align-items-center spacing-4">
        {{ Label }}
        @if (moreInfo) {
          <span
            ><app-ce-icon
              class="primary-50"
              [name]="'help'"
              [svg_class]="['d-flex']"
              [matTooltip]="tooltipContent"
              [matTooltipPosition]="'right'"></app-ce-icon
          ></span>
        }
      </div>
      @if (cues) {
        <ng-content select="[cues]"></ng-content>
      }
    </label>
    @if (tagLine) {
      <span class="h4-reg primary-60">{{ tagLine }}</span>
    }
    <div class="form-input position-relative" [ngClass]="{ 'value-error': state == 'warning' }">
      <input
        [class.d-none]="dropdown || multiSelect || multiSelectTags || nestedDropdown"
        [value]="value"
        type="{{ type }}"
        class="form-control h4-reg {{ state }} "
        [placeholder]="placeholder ? placeholder : Label ? Label : 'Enter your text here...'"
        (focus)="showCues(true)"
        (blur)="showCues(false)"
        (input)="updateValue($any($event.target)?.value)"
        (blur)="onBlur()"
        [formControlName]="name" />
      @if (info) {
        <div class="d-flex align-items-start spacing-8 mt-4">
          <app-ce-icon
            class="primary-50"
            [name]="'help'"
            [svg_class]="['d-flex']"
            [matTooltip]="tooltipContent"
            [matTooltipPosition]="'right'"></app-ce-icon>
          <div class="description primary-60 h4-reg">
            {{ description }}
          </div>
        </div>
      }
      @if (dropdown) {
        <div class="custom-select" [ngClass]="{ disabled: disabled }">
          <div class="select-wrapper">
            <div class="select-value h4-reg primary-60" (click)="toggleOptions()">
              @if (!warehouse) {
                <span>{{ selectedOption?.label || value }}</span>
              }
              @if (warehouse) {
                <span>{{ selecteditems }}</span>
              }
              @if (package) {
                <span>{{ selectedpackage }}</span>
              }
              @if (!selectedOption && !warehouse && !package) {
                <span class="">{{ optionPlaceholder }}</span>
              }
            </div>

            <div class="custom-dropdown options" [hidden]="!showOptions">
              @if (searchOption) {
                <div
                  class="w-100"
                  app-search
                  [active]="false"
                  [SearchBtn]="false"
                  [disabled]="false"
                  size="medium"
                  #searchInput
                  (onSearch)="onSearch($event)"></div>
              }
              @for (option of optionList; track option.value) {
                <div
                  class="option custom-scroll h4-reg primary-60"
                  (click)="selectOption(option, name)">
                  @if (!warehouse && !package) {
                    <dropdown-single-piece
                      [label]="option.label"
                      [color]="'default'"
                      [type]="'bold'"
                      [state]="'default'"
                      [icon]="false"
                      [iconType]="'balance'"
                      [dragDrop]="false"
                      [toggle]="false"
                      [more]="false"
                      [radio]="false"
                      [checkbox]="false"></dropdown-single-piece>
                  }
                </div>
              }
              @if (createNewOptions) {
                <div class="d-flex flex-column spacing-4 w-100">
                  <div class="border-line"></div>
                  <app-link-btn
                    class="pt-2 ms-2"
                    [label]="createOptionLabel"
                    [active]="false"
                    [size]="'large'"
                    [IconType]="'add'"
                    [alert]="false"
                    (custom_click)="createCustom.emit('createOption')"></app-link-btn>
                </div>
              }
              @if (warehouse) {
                <app-warehouse-dropdown
                  class="w-100"
                  (selectionChanged)="selectionChanged($event)"
                  [warehouses]="warehouses"></app-warehouse-dropdown>
              }
              @if (package) {
                <app-package-dropdown
                  class="w-100"
                  (setup)="onSetupNowClick()"
                  (selectionChanged)="selectionChanged($event)"
                  [package]="packages"></app-package-dropdown>
              }

              @if (footer) {
                <div class="w-100">
                  <div class="border-line"></div>
                  <ng-content select="[footer]"></ng-content>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (multiSelect) {
        <div class="custom-select">
          <div class="select-wrapper">
            <div class="select-value h4-reg primary-60" (click)="toggleOptions()">
              @if (selectedOptions.length > 0) {
                <span class="d-flex align-items-center spacing-4">
                  @for (option of selectedOptions; track option.value) {
                    <app-tags
                      [ellipsis]="true"
                      [label]="option.label"
                      [close]="true"
                      (dismiss)="dismissOption($event)"></app-tags>
                  }
                </span>
              }
              @if (selectedOptions.length === 0) {
                <span class="">{{ optionPlaceholder }}</span>
              }
            </div>
            <div class="d-flex flex-column spacing-4 optionlist" [hidden]="!showOptions">
              <div
                *ngIf="searchOption"
                class="w-100"
                app-search
                [active]="false"
                [SearchBtn]="false"
                [disabled]="false"
                size="medium"
                (onSearch)="onSearch($event)"></div>
              <div class="custom-dropdown options custom-scroll">
                @for (option of filteredOptions; track option.value) {
                  <div
                    class="option custom-scroll h4-reg primary-60"
                    (click)="multiSelectOption(option, name)">
                    <dropdown-single-piece
                      [label]="option.label"
                      [color]="'default'"
                      [type]="'bold'"
                      [state]="'default'"
                      [icon]="option.icon!!"
                      [iconType]="option.icon"
                      [dragDrop]="false"
                      [toggle]="false"
                      [more]="false"
                      [radio]="false"
                      [checkbox]="false"></dropdown-single-piece>
                  </div>
                }
                @if (filteredOptions.length === 0) {
                  <div class="create-custom">
                    <app-link-btn
                      [label]="'Create new'"
                      [active]="false"
                      [size]="'large'"
                      [alert]="false"
                      (custom_click)="createCustom.emit('create')"></app-link-btn>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }

      @if (multiSelectTags) {
        <div class="custom-select">
          <div class="select-wrapper d-flex spacing-8 flex-column">
            <input
              [class.d-none]="dropdown || multiSelect"
              type="{{ type }}"
              class="form-control h4-reg {{ state }} "
              [placeholder]="placeholder ? placeholder : Label ? Label : 'Enter your text here...'"
              (keyup.enter)="addTag()"
              (blur)="onBlur()"
              [formControlName]="name" />
            <div class="h4-reg d-flex gap-1 flex-wrap">
              <span class="d-flex align-items-center spacing-4 flex-wrap">
                @for (tag of tags; track tag; let i = $index) {
                  <app-tags
                    [ellipsis]="true"
                    [label]="tag"
                    [close]="true"
                    (dismiss)="dismissTags(i)"></app-tags>
                }
              </span>
            </div>
          </div>
        </div>
      }

      @if (nestedDropdown) {
        <ng-template #tmplNode let-option="option">
          <dropdown-single-piece
            [label]="option.label"
            [color]="'default'"
            [type]="'bold'"
            [icon]="option.icon!!"
            [iconType]="option.icon"
            [dragDrop]="false"
            [toggle]="false"
            [more]="true"
            [moreIcon]="
              option.children.length > 0 ? (option.isListOpen ? 'chevron_up' : 'chevron_down') : ''
            "
            [state]="option.isListOpen ? 'hover' : 'default'"
            [radio]="false"
            [checkbox]="isMultiSelect"
            [showBadge]="true"
            [badgeLabel]="option.children.length + ' Products'"
            (onCheckChange)="nestedOptionSelect(option, name)"
            (onAction)="isMultiSelect ? '' : nestedOptionSelect(option, name)"
            (customClick)="option.isListOpen = !option.isListOpen"></dropdown-single-piece>
          @if (option.isListOpen) {
            @for (child of option.children; track child) {
              <div class="h4-reg primary-60 nested">
                <ng-container
                  *ngTemplateOutlet="tmplNode; context: { option: child }"></ng-container>
              </div>
            }
          }
        </ng-template>
        <div class="custom-select">
          <div class="select-wrapper">
            <div
              class="select-value h4-reg primary-60"
              class="w-100"
              app-search
              [active]="false"
              [SearchBtn]="false"
              [disabled]="false"
              size="medium"
              (onSearch)="onSearch($event)"
              (click)="toggleOptions()"></div>

            <div class="d-flex flex-column spacing-4 optionlist" [hidden]="!showOptions">
              <div class="custom-dropdown options custom-scroll">
                @for (option of filteredOptions; track option.value; let i = $index) {
                  <div
                    class="option custom-scroll h4-reg primary-60"
                    [class]="toggleNav ? 'cursor-pointer' : 'toggleDisabled'">
                    <ng-container
                      *ngTemplateOutlet="tmplNode; context: { option: option }"></ng-container>
                  </div>
                }
              </div>
            </div>
          </div>

          @if (selectedOptions.length > 0) {
            <span class="d-flex align-items-center spacing-4 mt-4">
              @for (option of selectedOptions; track option.value) {
                <app-tags
                  [ellipsis]="true"
                  [label]="option.tagLabel || option.label"
                  [close]="true"
                  (dismiss)="dismissOption($event)"></app-tags>
              }
            </span>
          }
        </div>
      }

      @if (icon) {
        <span class="icon d-flex">
          <app-ce-icon [name]="'search'" [svg_class]="['d-flex']"></app-ce-icon>
        </span>
      }
      @if (state == 'success') {
        <span class="succes-icon d-flex">
          <app-ce-icon
            [name]="'box_with_check'"
            [svg_class]="['d-flex', 'success-120']"></app-ce-icon>
        </span>
      }
    </div>
    <span class="error-warning h4-reg">
      <app-ce-icon [name]="'alert'" [svg_class]="['d-flex']"></app-ce-icon>
      {{ error }}</span
    >
  </div>
}
@if (colorPicker) {
  <div class="classic-leftValue" [formGroup]="form">
    <label for="text-type" class="form-label h4-bold" [ngClass]="{ 'd-none': Label == '' }">{{
      Label
    }}</label>
    <div class="input-group" [ngClass]="{ 'value-error': state == 'warning' }">
      <div
        class="left-icon pt-0 pb-0 input-group-text {{ state }}"
        [class.focused]="isInputFocused">
        <div class="d-flex align-items-center spacing-16">
          <input
            class="p-0 colorbox"
            [(ngModel)]="colorchange"
            type="color"
            class="form-control h4-reg {{ state }} "
            [placeholder]="placeholder ? placeholder : Label ? Label : 'Enter your text here...'"
            (focus)="showCues(true)"
            (blur)="showCues(false)"
            (input)="updateValue($any($event.target)?.value)"
            (blur)="onBlur()"
            [formControlName]="name" />
        </div>
      </div>
      <input
        [ngModel]="colorchange"
        type="text"
        class="form-control h4-reg {{ state }} ps-0"
        [placeholder]="placeholder ? placeholder : Label ? Label : 'Enter your text here...'"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (input)="updateValue($any($event.target)?.value)"
        [formControlName]="name" />
    </div>
    <span class="error-warning h4-reg">
      <app-ce-icon [name]="'warning'" [svg_class]="['d-flex']"></app-ce-icon>
      {{ error }}</span
    >
  </div>
}

@if (suffix || prefix) {
  <div class="classic-withValue" [formGroup]="form">
    <label
      for="text-type"
      class="form-label h4-bold d-flex align-items-center spacing-4"
      [ngClass]="{ 'd-none': Label == '' }"
      >{{ Label }}
      @if (moreInfo) {
        <span
          ><app-ce-icon
            class="primary-50"
            [name]="'help'"
            [svg_class]="['d-flex']"
            [matTooltip]="tooltipContent"
            [matTooltipPosition]="'right'"></app-ce-icon
        ></span>
      }
    </label>
    <ng-template #toogle>
      <div class="ms-1 custom-tooltip">
        <app-tooltip [label]="tooltipContent" [Type]="'default'" [size]="'medium'"></app-tooltip>
      </div>
    </ng-template>
    @if (tagLine) {
      <span class="h4-reg primary-60">{{ tagLine }}</span>
    }
    <div class="d-flex spacing-4 align-items-start flex-column">
      @if (conditionLabel) {
        <label class="h4-bold primary-100">{{ conditionLabel }}</label>
      }
      <div class="input-group" [ngClass]="{ 'value-error': state == 'warning' }">
        @if (prefix) {
          <div class="left-icon input-group-text {{ state }} " [class.focused]="isInputFocused">
            <div class="d-flex align-items-center spacing-16">
              <app-badges
                [withIcon]="false"
                [Type]="prefixBadge.type"
                [IconType]="prefixBadge.icon"
                [counter]="false"
                [lowerCase]="true"
                [divideText]="''"
                [dividedText]="false"
                [close]="prefixBadge.rightIcon"
                [onlyIcon]="false"
                [label]="prefixBadge.label"
                [ellipsis]="true"></app-badges>
              @if (state == 'success') {
                <span class="d-flex">
                  <app-ce-icon
                    [name]="'box_with_check'"
                    [svg_class]="['d-flex', 'success-120']"></app-ce-icon>
                </span>
              }
              @if (prefixBadge.icon) {
                <div class="dropdown-menu">
                  <div class="custom-dropdown sufix-dropdown">
                    @for (items of prefixDropdown; track items) {
                      <dropdown-single-piece
                        class="cursor-pointer w-100"
                        [label]="items.name"
                        [color]="'default'"
                        [type]="'bold'"
                        [state]="'default'"
                        [icon]="false"
                        [iconType]="'balance'"
                        [dragDrop]="false"
                        [toggle]="false"
                        [more]="false"
                        [radio]="false"
                        [checkbox]="false"></dropdown-single-piece>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <input
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          (input)="updateValue($any($event.target)?.value)"
          type="{{ type }}"
          [formControlName]="name"
          aria-label="Text input with dropdown button"
          class="form-control position-relative h4-reg {{ state }}"
          [class.prefixInput]="prefix"
          [class.suffixInput]="suffix"
          id="text-type"
          [placeholder]="placeholder ? placeholder : Label ? Label : 'Enter your text here...'" />

        @if (suffix) {
          <div class="right-icon input-group-text {{ state }}" [class.focused]="isInputFocused">
            <div class="d-flex align-items-center spacing-16">
              @if (state == 'success') {
                <span class="d-flex">
                  <app-ce-icon
                    [name]="'box_with_check'"
                    [svg_class]="['d-flex', 'success-120']"></app-ce-icon>
                </span>
              }
              <app-badges
                [lowerCase]="true"
                [withIcon]="false"
                [Type]="suffixBadge.type"
                [IconType]="suffixBadge.icon"
                [counter]="false"
                [divideText]="''"
                [dividedText]="false"
                [close]="suffixBadge.rightIcon"
                [onlyIcon]="false"
                [label]="suffixBadge.label"
                [ellipsis]="true"></app-badges>
              @if (suffixBadge.icon == 'down_arrow') {
                <div class="dropdown-menu dropdown-menu-end">
                  <div class="custom-dropdown sufix-dropdown">
                    @for (items of suffixDropdown; track items) {
                      <dropdown-single-piece
                        class="cursor-pointer w-100"
                        [label]="items.name"
                        [color]="'default'"
                        [type]="'bold'"
                        [state]="'default'"
                        [icon]="false"
                        [iconType]="'balance'"
                        [dragDrop]="false"
                        [toggle]="false"
                        [more]="false"
                        [radio]="false"
                        [checkbox]="false"></dropdown-single-piece>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <span class="error-warning h4-reg">
        <app-ce-icon [name]="'warning'" [svg_class]="['d-flex']"></app-ce-icon>
        {{ error }}</span
      >
    </div>
  </div>
}

@if (stepCounter) {
  <div class="classic-withValue" [formGroup]="form">
    <label for="text-type" class="form-label h4-bold" [ngClass]="{ 'd-none': Label == '' }">{{
      Label
    }}</label>
    @if (tagLine) {
      <span class="h4-reg primary-60">{{ tagLine }}</span>
    }
    <div class="input-group" [ngClass]="{ 'value-error': state == 'warning' }">
      <input
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (input)="updateValue($any($event.target)?.value)"
        type="number"
        [formControlName]="name"
        aria-label="Text input with dropdown button"
        class="form-control position-relative h4-reg {{ state }}"
        id="text-type"
        autocomplete="off"
        [placeholder]="placeholder ? placeholder : Label ? Label : 'Enter your text here...'" />
      <div
        class="left-icon input-group-text {{ state }} d-flex align-items-center spacing-8"
        style="border-right: 1px solid var(--primary-40) !important"
        [class.focused]="isInputFocused">
        <app-action-btn
          [active]="false"
          [IconType]="'intermideate'"
          (custom_click)="onStep('decrease')"></app-action-btn>
        <app-action-btn
          [active]="false"
          [IconType]="'add'"
          (custom_click)="onStep('increase')"></app-action-btn>
      </div>
    </div>
    <!-- <span class="error-warning h4-reg">
    <app-ce-icon [name]="'warning'" [svg_class]="['d-flex']"></app-ce-icon>
    {{error}}</span> -->
  </div>
}
<ng-content></ng-content>
